import { LoginBgTop, LoginBgMobile } from '../../icon'
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors';

const UnAuthComponent = (WrapComponent) => {
    return function WrappedComponent(props) {
        const isMobileDevice = useSelector(selector.isMobileDevice);

        return (
            <div className={"bg-color-login d-flex h-v-100"}>
                <WrapComponent {...props} />
                {!isMobileDevice &&
                    <div className="login-rounded-top">
                        <LoginBgTop />
                    </div>
                }
                {isMobileDevice &&
                    <div className="login-rounded-bottom">
                        <LoginBgMobile className="" />
                    </div>
                }
            </div>
        );
    };
};

export default UnAuthComponent;